<div class="container-fluid">
  <mat-tab-group dynamicHeight mat-stretch-tabs>
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon svgIcon="rss" class="mr-2"></mat-icon>
        RSS feed
      </ng-template>
      <div class="row row-gap">
        <div class='row w-100 m-0'>
          <div class="col-md-3">
            <h6>Maximum age of articles</h6>
            <mat-select name="articlesAge" [(ngModel)]="rssConfigs.MaxAge" [disableOptionCentering]="true" panelClass="mat-location-select">
              <mat-option *ngFor="let value of maxAgeEnumValues; let i = index"
                [value]="i">{{ value }}
              </mat-option>
            </mat-select>
          </div>

          <div class="col-md-5">
            <h6>Text size</h6>
            <div class="row">
              <div class="col-md-10">
                <mat-slider #mySlider min="1" max="8" step="1" class="rss-speed-slider w-100" [(ngModel)]="rssConfigs.TextSize"
                  (input)="rssConfigs.TextSize = $event.value" thumbLabel name="rssSpeed">
                  <input matSliderThumb>
                </mat-slider>
              </div>
              <div class="d-flex justify-content-end align-items-center col-md-2 invisible-border">
                <input type="text" id="TextSize" class="w-100 rss-input" min="1" max="8" [value]="rssConfigs.TextSize"
                  (input)="onSliderKeyDown($event)" (focusout)="onInputFocusOut($event)">
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <h6>Scroll speed</h6>
            <div class="row">
              <div class="col-md-9">
                <mat-slider min="1" max="15" step="1" class="rss-speed-slider w-100" [(ngModel)]="rssConfigs.ScrollSpeed"
                  (input)="rssConfigs.ScrollSpeed = $event.value" thumbLabel name="rssSpeed">
                  <input matSliderThumb>
                </mat-slider>
              </div>
              <div class="d-flex justify-content-end align-items-center col-md-3 invisible-border">
                <input type="text" id="ScrollSpeed" class="w-100 rss-input" min="1" max="10" [value]="rssConfigs.ScrollSpeed"
                  (input)="onSliderKeyDown($event)" (focusout)="onInputFocusOut($event)">
              </div>
            </div>
          </div>
        </div>

        <div class="row w-100 m-0">
          <div class="row no-gutters col-md-3 pt-4 align-content-start">
            <div class="col-md-12">
              <mat-checkbox [disableRipple]="true" [(ngModel)]="rssConfigs.IncludeTitle" name="includeTitle"
                class="light rss-checkbox">
                Include title
              </mat-checkbox>
            </div>

            <div class="col-md-12">
              <mat-checkbox [disableRipple]="true" [(ngModel)]="rssConfigs.IncludeContent" name="includeContent"
                class="light rss-checkbox">
                Include content
              </mat-checkbox>
            </div>
          </div>

          <div class="row no-gutters col-md-5 justify-content-between">
            <div class="col-md-6">
              <div class="col-md-12 mb-3 pl-0">
                <h6 class="mb-2">Text color</h6>
                <ng-container color-picker>
                  <app-color-picker [(color)]="rssConfigs.TextColor" [position]="'left'" [isInputHidden]="true"
                    [label]="null" [outputFormat]="'rgba'"></app-color-picker>
                </ng-container>
              </div>

              <div class="col-md-12 pl-0">
                <h6 class="mb-2">Background color</h6>
                <ng-container color-picker>
                  <app-color-picker [(color)]="rssConfigs.BackgroundColor" [position]="'top'" [isInputHidden]="true"
                    [label]="null" [outputFormat]="'rgba'"></app-color-picker>
                </ng-container>
              </div>
            </div>

            <div class="col-md-6">
              <div class="col-md-12 pr-0 d-flex flex-column h-100">
                  <h6 class="mb-2">Scroll direction</h6>
                  <mat-radio-group aria-label="Select an option" [(ngModel)]="rssConfigs.ScrollDirection">
                    <mat-radio-button [value]="scrollDirections.RightToLeft">Right to Left</mat-radio-button>
                    <mat-radio-button [value]="scrollDirections.LeftToRight">Left to Right</mat-radio-button>
                  </mat-radio-group>
              </div>
            </div>
          </div>
            <div class="row col-md-4 justify-content-between">
              <div class="col-md-9">
                <div class="monitor" [ngStyle]="{ height: monitorHeight + 'px' }">
                  <div class="rss-block"
                    [ngStyle]="{
                      height: rssBlockHeight + 'px',
                      backgroundColor: rssConfigs.BackgroundColor,
                      bottom: rssConfigs.PositionY | calcucateRssPosition: monitorHeight: rssBlockHeight
                    }">
                    <mat-icon [ngStyle]="{ color: rssConfigs.TextColor }"
                      [svgIcon]="rssConfigs.ScrollDirection === scrollDirections.RightToLeft ? 'arrow_back' : 'arrow_forward'"></mat-icon>
                  </div>
                </div>
              </div>
            @if (isAndroidPlaylist) {
              <div class="col-md-3 d-flex flex-column align-items-center">
                <h6>Position</h6>
                <mat-slider class="rss-position-slider" min="0" max="100" step="1" [(ngModel)]="rssConfigs.PositionY"
                  (input)="rssConfigs.PositionY = $event.value" thumbLabel vertical name="positionY">
                  <input matSliderThumb>
                </mat-slider>
              </div>
            }
          </div>
        </div>
      </div>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon svgIcon="clock" class="mr-2"></mat-icon>
        Clock settings
      </ng-template>
      <div class="row row-gap">
        <div class="row w-100 m-0">
          <div class="row no-gutters col-md-4 align-items-end">
            <div class="col-md-12">
              <mat-checkbox [disableRipple]="true" [(ngModel)]="rssConfigs.ShowClock" name="showClock"
                class="light rss-checkbox">
                Show clock
              </mat-checkbox>
            </div>
            <div class="col-md-12">
              <mat-checkbox [disableRipple]="true" [disabled]="!rssConfigs.ShowClock" [(ngModel)]="rssConfigs.ShowSeconds" name="showSeconds"
                class="light rss-checkbox">
                Show seconds
              </mat-checkbox>
            </div>
          </div>

          <div class="col-md-4">
            <h6 class="mb-3">Format</h6>
            <mat-radio-group aria-label="Select an option" [(ngModel)]="rssConfigs.ClockFormat" [disabled]="!rssConfigs.ShowClock">
              <mat-radio-button [value]="clockFormat.TwelveHour">12h</mat-radio-button>
              <mat-radio-button class="ml-3" [value]="clockFormat.TwentyFourHour">24h</mat-radio-button>
            </mat-radio-group>
          </div>

          <div class="col-md-4">
            <h6 class="mb-3">Placement</h6>
            <mat-radio-group aria-label="Select an option" [(ngModel)]="rssConfigs.ClockPosition" [disabled]="!rssConfigs.ShowClock">
              <mat-radio-button [value]="clockPlacement.Left">Left</mat-radio-button>
              <mat-radio-button class="ml-3" [value]="clockPlacement.Right">Right</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>

  <div class="footer">
    <div class="col-12 d-flex justify-content-end p-0">
      <button matTooltip="Cancel" mat-raised-button type="button" class="mr-3" (click)="cancel()">
        Cancel
      </button>
      <button matTooltip="Save RSS Ticker configuration" mat-raised-button type="button" (click)="save()">
        Save
      </button>
    </div>
  </div>
</div>

